import { ScreenWaveLoader } from '@/shared'
import loadable from '@loadable/component'

export const AuthenticatedRoutesLazy = loadable(
  () => import('./AuthenticatedRoutes'),
  {
    fallback: <ScreenWaveLoader />
  }
)
